import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { environment } from "environments/environment";
import { QuoteEmailAttachment } from "./models/email-attachment.model";

export interface AttachmentDeleteReason {
  value: string;
  label: string;
}

@Injectable()
export class QuoteAttachmentRepository {
  private http = inject(HttpClient);

  /**
   * Asks for a short-lived signed link rather than streaming the bytes, so the browser's own image
   * and PDF viewers do the work. The link is a bearer credential for its lifetime, so it is fetched
   * at the moment of use and never held on to.
   */
  public getUrl(
    quoteId: number,
    attachment: QuoteEmailAttachment,
    download = false,
  ): Observable<string> {
    return this.http
      .get<{ url: string }>(
        `${environment.apiUrl}/quote/${quoteId}/attachment/${attachment.getId()}/url`,
        { params: { download } },
      )
      .pipe(map((response) => response.url));
  }

  public delete(
    quoteId: number,
    attachment: QuoteEmailAttachment,
    reason: string,
  ): Observable<void> {
    return this.http.delete<void>(
      `${environment.apiUrl}/quote/${quoteId}/attachment/${attachment.getId()}`,
      { params: { reason } },
    );
  }

  /** The reasons come from the server so the UI cannot drift from what the API accepts. */
  public getDeleteReasons(
    quoteId: number,
  ): Observable<AttachmentDeleteReason[]> {
    return this.http.get<AttachmentDeleteReason[]>(
      `${environment.apiUrl}/quote/${quoteId}/attachment/delete-reason`,
    );
  }
}
